/**
 * Subscription / plan client-side helpers.
 * Single source of truth for module gating + trial state in the React tree.
 */

export const MODULE_LABELS = {
  attendance: "Attendance",
  payroll: "Payroll",
  tasks: "Task Management",
  multi_outlet: "Multi-Outlet Tracking",
  reports: "Reports & Exports",
  assets: "Assets Management",
  referrals: "Employee Referrals",
  performance: "Performance Reviews",
};

export function planModules(sub) {
  return (sub?.plan?.modules) || null;
}

export function hasModule(sub, moduleName) {
  // Platform admins are not bound by tenant plans
  if (sub?.is_platform) return true;
  const mods = planModules(sub);
  if (!mods) return true; // No subscription = no gate (e.g. trial unconfigured)
  return Boolean(mods[moduleName]);
}

export function trialBannerCopy(sub) {
  if (!sub || !sub.plan) return null;
  const dl = sub.days_left;
  const status = sub.effective_status;
  if (status === "suspended") {
    return {
      tone: "danger",
      headline: "Workspace suspended",
      body: "Your subscription has been suspended. Contact support to reactivate the tenant.",
    };
  }
  if (status === "past_due") {
    return {
      tone: "danger",
      headline: "Subscription past due",
      body: `Your ${sub.plan.name} plan expired ${dl === null || dl === undefined ? "recently" : `${Math.abs(dl)} day${Math.abs(dl) === 1 ? "" : "s"} ago`}. Renew to keep using HRBo.`,
    };
  }
  if (status === "trial") {
    if (dl === null || dl === undefined) return null;
    if (dl <= 0) {
      return {
        tone: "danger",
        headline: "Trial expired",
        body: `Your ${sub.plan.name} trial ended. Upgrade to continue using HRBo.`,
      };
    }
    if (dl <= 7) {
      return {
        tone: "warning",
        headline: `Trial ends in ${dl} day${dl === 1 ? "" : "s"}`,
        body: `You're on the ${sub.plan.name} free trial. Pick a plan to keep your workspace active.`,
      };
    }
    return {
      tone: "info",
      headline: `${dl} days left on your trial`,
      body: `You're trying the ${sub.plan.name} plan. Switch anytime to lock in annual savings.`,
    };
  }
  return null;
}

export function usageWarning(sub) {
  if (!sub?.plan || !sub?.usage) return null;
  const limit = sub.plan.base_employee_limit || 0;
  if (limit <= 0) return null;
  const used = sub.usage.active_employees || 0;
  if (used >= limit) {
    return `You're at your ${sub.plan.name} plan limit (${used}/${limit} employees). Upgrade to add more.`;
  }
  if (used / limit >= 0.8) {
    return `Approaching plan limit: ${used}/${limit} employees on ${sub.plan.name}.`;
  }
  return null;
}
